import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

// Public
export const fetchSettings = () => client.get("/settings").then((r) => r.data);
export const fetchMenu = () => client.get("/menu").then((r) => r.data);
export const fetchSpecials = () => client.get("/specials").then((r) => r.data);
export const fetchReviews = () => client.get("/reviews").then((r) => r.data);
export const submitContact = (payload) => client.post("/contact", payload).then((r) => r.data);

// Auth
export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me").then((r) => r.data);

// Admin
export const adminListContact = () => client.get("/admin/contact").then((r) => r.data);
export const adminDeleteContact = (id) => client.delete(`/admin/contact/${id}`).then((r) => r.data);
export const adminSaveSettings = (payload) => client.put("/admin/settings", payload).then((r) => r.data);
export const adminCreateCategory = (payload) => client.post("/admin/categories", payload).then((r) => r.data);
export const adminUpdateCategory = (id, payload) => client.put(`/admin/categories/${id}`, payload).then((r) => r.data);
export const adminDeleteCategory = (id) => client.delete(`/admin/categories/${id}`).then((r) => r.data);
export const adminCreateItem = (payload) => client.post("/admin/items", payload).then((r) => r.data);
export const adminUpdateItem = (id, payload) => client.put(`/admin/items/${id}`, payload).then((r) => r.data);
export const adminDeleteItem = (id) => client.delete(`/admin/items/${id}`).then((r) => r.data);
export const adminCreateSpecial = (payload) => client.post("/admin/specials", payload).then((r) => r.data);
export const adminUpdateSpecial = (id, payload) => client.put(`/admin/specials/${id}`, payload).then((r) => r.data);
export const adminDeleteSpecial = (id) => client.delete(`/admin/specials/${id}`).then((r) => r.data);
